export default __webpack_public_path__ + "static/media/icon_organization.cfe221c1.svg";